export const moduleCategoriesOpts = [
	{
		text: 'Parts',
		value: 1
	},
	{
		text: 'Service',
		value: 2
	},
	{
		text: 'Accounting',
		value: 3
	},
	{
		text: 'Common/General',
		value: 4
	},
	{
		text: 'Sales ',
		value: 5
	}
];

export const essentialOpts = [
	{
		text: 'Essential',
		value: 1
	},
	{
		text: 'Non-Essential',
		value: 0
	}
];

export const directionOpts = [
	{
		text: 'Inbound',
		value: 'I'
	},
	{
		text: 'Outbound',
		value: 'O'
	},
	{
		text: 'Bi-Directional',
		value: 'B'
	}
];
